<template>
  <main :class="['v-view-primary', $store.getters.getIsClientData === false
    ? 'v-view-primary-upgrade' : '']">
    <OrganismTheHeader :is-loading="isLoading"/>
    <OrganismFeedSectionLoading
      v-if="showLoadingState < 2"
      key="loadingState"
    />
    <OrganismFeedSectionEmpty
      v-else-if="elements.length === 0"
      key="emptyState"
    />
    <OrganismFeedSectionContent
      v-else
      key="idealState"
      :element-categorias="elementCategorias"
      :elements="elements"
      :showAddingState="showAddingState"
    />
  </main>
</template>

<script>
export default {
  name: 'FeedSection',

  components: {
    OrganismFeedSectionLoading: () => import('@/components/organisms/OrganismFeedSectionLoading'),
    OrganismFeedSectionEmpty: () => import('@/components/organisms/OrganismFeedSectionEmpty'),
    OrganismFeedSectionContent: () => import('@/components/organisms/OrganismFeedSectionContent')
  },

  data () {
    return {
      academiaId: '',
      bottomPage: false,
      elementCategorias: [],
      elements: [],

      filter: {
        tipo: 0
      },

      isLoading: false,
      list: [],
      showAddingState: false,
      showLoadingState: 0
    }
  },

  watch: {
    bottomPage (bottomPage) {
      if (bottomPage && this.list.length > 0) {
        this.showAddingState = true
        this.elements = this.elements.concat(this.list.splice(0, 1000))
      }
      this.showAddingState = false
    },

    $route (to, from) {
      this.resetData()
      this.readInscripcionesAlumno()
      this.readProyectoCategorias()
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id

    window.addEventListener('scroll', () => {
      this.bottomPage = this.$utils.bottomVisible()
    })

    if (this.$route.name === 'home' || this.$route.name === 'assets') {
      this.$store.commit('unsetProyect')
      this.$store.commit('unsetSelectedNode')
      this.$store.commit('unsetProyectNodes')
      this.$store.commit('unsetProyectNodesEnrollment')
    } else {
      this.$store.commit('unsetMap')
      this.$store.commit('unsetSelectedMapNode')
      this.$store.commit('unsetMapNodes')
      this.$store.commit('unsetMapNodesEnrollment')
    }

    this.readInscripcionesAlumno()
    this.readProyectoCategorias()
  },

  methods: {
    readElements () {
      this.list = this.$route.name === 'home' || this.$route.name === 'assets'
        ? this.list = [...this.$store.getters.getStudentEnrollments]
        : this.list = [...this.$store.getters.getStudentMapEnrollments]
      this.elements = [...this.elements.concat(this.list.splice(0, 1000))]
    },

    readInscripcionesAlumno () {
      if (!this.isLoading) {
        this.isLoading = true
        this.filter.tipo = (this.$route.name === 'home' || this.$route.name === 'assets') ? 0 : 1
        this.$services.read('inscripcion', 'readInscripcionesAlumno', {}, [this.academiaId], this.filter)
          .then(response => {
            console.log(response)
            if (this.$route.name === 'home' || this.$route.name === 'assets') {
              this.$store.commit('setStudentEnrollments', response.data)
            } else {
              this.$store.commit('setStudentMapEnrollments', response.data)
            }
            this.showLoadingState++
            this.isLoading = false
            this.readElements()
          })
          .catch(error => {
            console.log(error)
            this.isLoading = false
          })
      }
    },

    readProyectoCategorias () {
      this.elementCategorias = []
      this.$services.read('proyecto', 'readProyectoCategorias')
        .then(response => {
          this.elementCategorias = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    resetData () {
      this.bottomPage = false
      this.elements = []
      this.filter.tipo = 0
      this.list = []
      this.showAddingState = false
      this.showLoadingState = 0
    }
  }
}
</script>
